import { StepShell, AvatarUpload, SectionGroup } from '../components/layout';
import { TextField, DateField, SearchSelect } from '../components/inputs';
import { ChoiceCards } from '../components/selection';
import { NATIONALITIES } from '../lists';

export default function PersonalStep({
  data, update, notes = {}, config, profile, uploadPhoto, removePhoto, photoBusy,
}) {
  return (
    <StepShell
      eyebrow="Step 1 of 18"
      title="Let’s start with you"
      lede="The basics first — this is the part you have probably filled in a hundred times, so we have kept it short."
    >
      <AvatarUpload
        url={profile?.photo_url}
        onFile={uploadPhoto}
        onRemove={removePhoto}
        busy={photoBusy}
      />

      <SectionGroup label="Your details">
        <TextField
          id="full_name"
          label="Full name"
          placeholder="e.g. Muhammad Ali Khan"
          autoComplete="name"
          value={data.full_name}
          note={notes.full_name}
          onChange={(v) => update({ full_name: v })}
        />

        <TextField
          id="father_name"
          label="Father’s or guardian’s name"
          placeholder="e.g. Tariq Khan"
          value={data.father_name}
          note={notes.father_name}
          onChange={(v) => update({ father_name: v })}
        />

        <div className="ob-grid2">
          <DateField
            id="dob"
            label="Date of birth"
            value={data.dob}
            note={notes.dob}
            max={new Date().toISOString().slice(0, 10)}
            onChange={(v) => update({ dob: v })}
          />

          <SearchSelect
            id="nationality"
            label="Nationality"
            optional
            options={NATIONALITIES}
            placeholder="Pakistani"
            value={data.nationality}
            note={notes.nationality}
            onChange={(v) => update({ nationality: v })}
          />
        </div>
      </SectionGroup>

      <SectionGroup label="A little more">
        <ChoiceCards
          label="Gender"
          options={config.genders}
          value={data.gender}
          note={notes.gender}
          columns={2}
          onChange={(v) => update({ gender: v })}
        />

        <TextField
          id="religion"
          label="Religion"
          optional
          value={data.religion}
          note={notes.religion}
          onChange={(v) => update({ religion: v })}
        />
      </SectionGroup>
    </StepShell>
  );
}
